let columns = [{
    id:1,
    prop: "selection",
    label: "",
    width: "55"
}, {
    id:2,
    prop: "index",
    label: "序号",
    width: "55"
}, {
    id:3,
    prop: "stu_name",
    label: "学生姓名",
    width: "55"
},{id:4,prop: "gender",label: "性别",width: "60"},
{id:5,prop: "stu_code",label: "学号",width: "55"},
{id:6,prop: "archive",label: "建档号",width: "55"},
{id:7,prop: "exam_num",label: "考试证号",width: "55"},
{id:8,prop: "exam_num",label: "准考证号",width: "55"},
{id:9,prop: "identity_card",label: "身份证号",width: "55"},
{id:10,prop: "birthday",label: "出生日期",width: "55"},
{id:101,prop: "yuanxi",label: "院系",width: "55"},
{id:102,prop: "xuezhi",label: "学制",width: "55"},
{id:103,prop: "major_name",label: "专业",width: "55"},
{id:12,prop: "major_name2",label: "专业二",width: "55"},
{id:13,prop: "major_name3",label: "专业三",width: "55"},
{id:14,prop: "exam_score",label: "中考总分",width: "55"},
{id:15,prop: "exam_score",label: "成绩总分",width: "55"},
{id:16,prop: "volunteer",label: "报考志愿",width: "55"},
{id:17,prop: "graduate_sch_city",label: "毕业地区",width: "55"},
{id:117,prop: "sch_city",label: "毕业城市",width: "55"},
{id:118,prop: "graduate_sch_city",label: "所在地区",width: "55"},
{id:18,prop: "graduate_schname",label: "毕业学校",width: "55"},
{id:19,prop: "phone",label: "联系电话",width: "55"},
{id:20,prop: "status",label: "状态",width: "55"},
{id:21,prop: "dorm",label: "是否住宿",width: "55"},
{id:22,prop: "remark",label: "备注",width: "55"},
{id:23,prop: "minzu",label: "民族",width: "55"},
{id:24,prop: "zzmm",label: "政治面貌",width: "55"},
{id:25,prop: "jiguan",label: "籍贯",width: "55"},
{id:26,prop: "hkszd",label: "户口所在地",width: "55"},
{id:27,prop: "hkszdpcs",label: "户口所在地派出所",width: "55"},
{id:28,prop: "hkxz",label: "户口性质",width: "55"},
{id:29,prop: "jzdtype",label: "居住地类型",width: "55"},
{id:30,prop: "jtzz",label: "家庭地址",width: "55"},
{id:31,prop: "jhr1name",label: "监护人",width: "55"},
{id:32,prop: "jhr1phone",label: "监护人电话",width: "55"},
{id:33,prop: "jhr2name",label: "监护人2",width: "55"},
{id:34,prop: "jhr2phone",label: "监护人2电话",width: "55"},
{id:35,prop: "phone2",label: "备用手机",width: "55"},
{id:36,prop: "fee_idx",label: "缴费序号",width: "55"},
{id:306,prop: "fee_idx",label: "报道号",width: "55"},
{id:316,prop: "stu_idx",label: "报名序号",width: "55"},
{id:37,prop: "ctype",label: "录取类型",width: "55"},
{id:38,prop: "oldname",label: "曾用名",width: "55"},
{id:39,prop: "pinyin",label: "姓名拼音",width: "55"},
{id:40,prop: "flag",label: "录取标志",width: "55"},
{id:41,prop: "username",label: "录入员",width: "55"},
{id:42,prop: "cdate",label: "录入时间",width: "55"},
{id:43,prop: "sp_user",label: "审核员",width: "55"},
{id:44,prop: "sp_time",label: "审核时间",width: "55"},
{id:45,prop: "jf_user",label: "缴费员",width: "55"},
{id:46,prop: "jf_time",label: "缴费时间",width: "55"},
{id:47,prop: "xy_user",label: "协议员",width: "55"},
{id:48,prop: "xy_time",label: "协议时间",width: "55"},
{id:49,prop: "",label: "",width: "55"},
]

export default {
    columns
}